var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlugged(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svgFill",
    d: "M195.5 82.5L193 80l43.5-43.5a12 12 0 0 0-17-17L176 63l-2.5-2.5a36 36 0 0 0-51 0L100 83.1A12 12 0 0 0 83.1 100l-22.6 22.5a36 36 0 0 0 0 51L63 176l-43.5 43.5a12 12 0 0 0 0 17a12.1 12.1 0 0 0 17 0L80 193l2.5 2.5a36.2 36.2 0 0 0 51 0l22.5-22.6a11.7 11.7 0 0 0 8 3.1a12.2 12.2 0 0 0 8.5-3.5a12 12 0 0 0 .4-16.5l22.6-22.5a36 36 0 0 0 0-51Zm-79 96a12 12 0 0 1-17 0l-22-22a12 12 0 0 1 0-17L100 117l39 39Zm62-62L156 139l-39-39l22.5-22.5a11.8 11.8 0 0 1 17 0l22 22a12 12 0 0 1 0 17Zm-5.8 107.7a12 12 0 0 1-22.8 7.6l-5.3-16a12 12 0 0 1 22.8-7.6ZM83.3 31.8a12 12 0 1 1 22.8-7.6l5.3 16a12 12 0 0 1-7.6 15.2a12.6 12.6 0 0 1-3.8.6a12.1 12.1 0 0 1-11.4-8.2Zm156.1 133.3a12 12 0 0 1-11.4 8.2a12.6 12.6 0 0 1-3.8-.6l-16-5.3a12 12 0 0 1 7.6-22.8l16 5.3a12 12 0 0 1 7.6 15.2ZM16.6 90.9a12 12 0 0 1 15.2-7.6l16 5.3A12 12 0 0 1 44 112a12.6 12.6 0 0 1-3.8-.6l-16-5.3a12 12 0 0 1-7.6-15.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugged);
export default __webpack_public_path__ + "static/media/plugged.48ac5e16.svg";
export { ForwardRef as ReactComponent };